import { render, staticRenderFns } from "./new_purchase_form.vue?vue&type=template&id=2a67d348&scoped=true"
import script from "./new_purchase_form.vue?vue&type=script&lang=js"
export * from "./new_purchase_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67d348",
  null
  
)

export default component.exports